import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';

export default class SelectStore {
    static OptionValuePropType = PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
        PropTypes.bool.isRequired,
    ]);

    static OptionPropType = PropTypes.shape({
        value: SelectStore.OptionValuePropType.isRequired,
        label: PropTypes.string,
    });

    static PropType = PropTypes.shape({
        options: MobxPropTypes.arrayOrObservableArrayOf(SelectStore.OptionPropType).isRequired,
        value: SelectStore.OptionValuePropType,

        setRef: PropTypes.func.isRequired,
        focus: PropTypes.func.isRequired,
        blur: PropTypes.func.isRequired,
        setOptions: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        this.ref = null;

        extendObservable(this, /** @class SelectStore */{
            value: null,
            options: [],
        }, data);
    }

    setRef = (newRef) => {
        this.ref = newRef;
    };

    focus = () => {
        if (this.ref && this.ref.focus) {
            this.ref.focus();
        }
    };

    blur = () => {
        if (this.ref && this.ref.blur) {
            this.ref.blur();
        }
    };

    setOptions = action((options) => {
        this.options.replace(options);
        this.setValue(this.value);
    });

    setValue = action((value) => {
        if (this.options.some((option) => option.value === value)) {
            this.value = value;
        } else {
            this.value = null;
        }
    });

    getValue = () => this.value;

    isSelected() {
        return this.value !== null;
    }
}

